// @flow

import {
  createApolloCache,
  createApolloClient,
} from '@atlassian/mpac-services-client/apollo-graphql-gateway';
import { createBrowserHistory } from 'history';

import BootstrapConfigSingleton from '../bootstrapConfig';
import { APOLLO_CLIENT_NAME, APOLLO_CLIENT_VERSION } from '../constants';
import { createStore, initializeStore } from '../store';

import type { BootstrapConfig } from '../../../application-config/types/BootstrapConfig';
import type { Store } from '../store';
import type { ApolloGraphQLGatewayClient } from '@atlassian/mpac-services-client/apollo-graphql-gateway';
import type { BrowserHistory } from 'history/createBrowserHistory';

export const initAceAnalytics = (bootstrapConfig: BootstrapConfig) => {
  if (!window.ace) return;

  const { featureFlags, analytics } = bootstrapConfig;

  window.ace.analytics.Initializer.initWithPageAnalytics(analytics.aceAnalytics.writeKey, {
    featureFlags,
    poweredBy: 'AMKT_FRONTEND',
    gasv3Product: 'marketplace',
  });
};

const getApolloCache = () => {
  const shouldHydrate =
    typeof window.__INITIAL_STATE__ !== 'undefined' &&
    !!window.__INITIAL_STATE__.apolloInitialState;

  if (shouldHydrate) {
    const cache = window.__INITIAL_STATE__.apolloInitialState;
    return createApolloCache(cache);
  }

  return createApolloCache();
};

const getReduxStore = (bootstrapConfig: BootstrapConfig) => {
  /* TODO: MC-2308
   * Hydrate redux store after figuring out serialization/deserialization of Immutable objects.
   */

  // const shouldHydrate =
  //   typeof window.__INITIAL_STATE__ !== 'undefined' && !!window.__INITIAL_STATE__.reduxInitialState;

  // if (shouldHydrate) {
  //   const initialState = window.__INITIAL_STATE__.reduxInitialState;
  //   return createStore({ initialState });
  // }

  const reduxStore = createStore();
  initializeStore(reduxStore, { bootstrapConfig });

  return reduxStore;
};

export type BrowserRenderContext = {|
  bootstrapConfig: BootstrapConfig,
  apolloClient: ApolloGraphQLGatewayClient,
  reduxStore: Store,
  browserHistory: BrowserHistory,
|};

export const createBrowserRenderContext = (
  bootstrapConfig: BootstrapConfig
): BrowserRenderContext => {
  BootstrapConfigSingleton.set(bootstrapConfig);

  const browserHistory = createBrowserHistory();

  const reduxStore = getReduxStore(bootstrapConfig);

  const apolloCache = getApolloCache();
  const apolloClient = createApolloClient({
    uri: bootstrapConfig.graphQLGatewayUrl,
    name: APOLLO_CLIENT_NAME,
    version: APOLLO_CLIENT_VERSION,
    cache: apolloCache,
    ssrMode: false,
  });

  return { reduxStore, bootstrapConfig, apolloClient, browserHistory };
};
